/// <amd-module name="TFS/DRITools/util/Date" />
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function parseDate(d: Date): string {
    return (
        d.getFullYear() +
        "-" +
        (d.getMonth() < 9 ? "0" : "") +
        (d.getMonth() + 1) +
        "-" +
        (d.getDate() < 10 ? "0" : "") +
        d.getDate() +
        " " +
        (d.getHours() < 10 ? "0" : "") +
        d.getHours() +
        ":" +
        (d.getMinutes() < 10 ? "0" : "") +
        d.getMinutes() +
        ":" +
        (d.getSeconds() < 10 ? "0" : "") +
        d.getSeconds() +
        "." +
        d.getMilliseconds()
    );
}

export function parseDateAMPM(d: Date): string {
    let hrs = d.getHours() % 12;
    if (hrs == 0) {
        hrs = 12;
    }
    return (
        d.getFullYear() +
        "-" +
        (d.getMonth() < 9 ? "0" : "") +
        (d.getMonth() + 1) +
        "-" +
        (d.getDate() < 10 ? "0" : "") +
        d.getDate() +
        " " +
        (hrs < 10 ? "0" : "") +
        hrs +
        ":" +
        (d.getMinutes() < 10 ? "0" : "") +
        d.getMinutes() +
        " " +
        (d.getHours() / 12 >= 1 ? "PM" : "AM")
    );
}
